import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ArrowRight } from 'lucide-react';
import { navLinks } from '../mock/mock';
import BrandMark from './BrandMark';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'py-3 bg-white/90 backdrop-blur-md border-b border-slate-200 shadow-[0_4px_24px_-12px_rgba(15,23,42,0.15)]' : 'py-5 bg-transparent'}`}>
      <nav className="max-w-7xl mx-auto px-5 md:px-8 flex items-center justify-between gap-4">
        <BrandMark />
        <ul className="hidden lg:flex items-center gap-0.5">
          {navLinks.map((l) => {
            const active = location.pathname === l.to;
            return (
              <li key={l.to}>
                <Link data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`} to={l.to} className={`relative px-3.5 py-2 rounded-full text-sm font-medium transition-colors ${active ? 'text-blue-600' : 'text-slate-600 hover:text-slate-900'}`}>
                  {l.label}
                  {active && <span className="absolute left-1/2 -translate-x-1/2 -bottom-0.5 w-6 h-0.5 rounded-full bg-blue-600" />}
                </Link>
              </li>
            );
          })}
        </ul>
        <Link data-testid="navbar-cta-button" to="/contact" className="hidden lg:inline-flex items-center gap-1.5 rounded-full bg-blue-600 px-5 py-2.5 text-sm font-semibold text-white hover:bg-blue-700 transition-colors shadow-lg shadow-blue-600/25">
          Let's Talk <ArrowRight size={15} />
        </Link>
        <button data-testid="navbar-mobile-toggle" className="lg:hidden text-slate-900 p-2" onClick={() => setOpen((v) => !v)} aria-label="Toggle menu">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden mt-3 mx-4 rounded-2xl bg-white border border-slate-200 shadow-xl p-4">
          <ul className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <li key={l.to}>
                <Link data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`} to={l.to} className={`block px-4 py-3 rounded-xl text-sm font-medium ${location.pathname === l.to ? 'text-blue-600 bg-blue-50' : 'text-slate-700 hover:bg-slate-50'}`}>{l.label}</Link>
              </li>
            ))}
            <li>
              <Link to="/contact" className="mt-2 block text-center rounded-full bg-blue-600 px-5 py-3 text-sm font-semibold text-white">Let's Talk</Link>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
